"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = require("underscore");

var _SampleEventFactoryInterface = _interopRequireDefault(require("crm_ui/utils/sampleData/SampleEventFactoryInterface"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _TimelineConstants = require("crm_universal/timeline/TimelineConstants");

var EMAIL_OPEN = _TimelineConstants.TRACKED_EVENT_TYPES.EMAIL_OPEN;
var makeEmailOpenSampleTimelineEvent = (0, _SampleEventFactoryInterface.default)({
  requiredData: {
    eventType: _TimelineConstants.EVENT_SIDEKICK,
    itemType: _EngagementTypes.EMAIL
  },
  eventDefaults: {
    subject: '',
    sources: []
  },
  build: function build(emailOpenData) {
    var subject = emailOpenData.subject,
        sources = emailOpenData.sources;
    var eventData = {
      type: EMAIL_OPEN,
      tracker_key: "" + (0, _underscore.uniqueId)(),
      object: subject,
      sources: sources.map(function (source) {
        source = (0, _underscore.defaults)(source, {
          created: Date.now()
        });
        var _source = source,
            domain = _source.domain,
            email = _source.email,
            created = _source.created;
        return {
          domain: domain,
          email: email,
          guid: "" + (0, _underscore.uniqueId)(),
          is_exact: true,
          is_mobile: false,
          link: '',
          location: '',
          name: name,
          timestamp: created
        };
      })
    };
    return eventData;
  }
});
var _default = makeEmailOpenSampleTimelineEvent;
exports.default = _default;
module.exports = exports.default;